export default __webpack_public_path__ + "static/media/logo.6709cdf5.png";